interface HistoryMessageListProps {
  title: string
  messages: string[]
  tone: 'problem' | 'warning' | 'info'
}

const TONE_CLASSES: Record<HistoryMessageListProps['tone'], string> = {
  problem: 'border-destructive/40 text-destructive',
  warning: 'border-amber-300 text-amber-800',
  info: 'border-border/80 text-muted-foreground'
}

export function HistoryMessageList({ title, messages, tone }: HistoryMessageListProps): React.ReactElement | null {
  if (messages.length === 0) return null

  return (
    <div className={`rounded-md border p-3 text-sm ${TONE_CLASSES[tone]}`}>
      <p className="font-medium">{title}</p>
      <ul className="mt-1 list-disc space-y-0.5 pl-5">
        {messages.map((message) => (
          <li key={message}>{message}</li>
        ))}
      </ul>
    </div>
  )
}
